"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var switchHeight = 32;
var switchWidth = 64;
var sliderMargin = 3;
var sliderDiameter = switchHeight - sliderMargin * 2;
var compactSwitchHeight = 20;
var compactSwitchWidth = 32;
var compactSliderMargin = 2;
var compactSliderDiameter = compactSwitchHeight - compactSliderMargin * 2;

exports.styles = function (_a) {
  var fontFamily = _a.fontFamily,
      colorPrimary = _a.colorPrimary,
      colorBorder = _a.colorBorder,
      colorIconContrast = _a.colorIconContrast,
      colorIconSecondary = _a.colorIconSecondary,
      toneValueBase = _a.toneValueBase,
      transitionEasingDefault = _a.transitionEasingDefault,
      animationDurationM = _a.animationDurationM,
      animationDurationS = _a.animationDurationS;
  return {
    base: {
      fontFamily: fontFamily,
      position: 'relative',
      width: switchWidth,
      height: switchHeight,
      userSelect: 'none',
      cursor: 'pointer',
      transition: "all " + animationDurationM + " " + transitionEasingDefault,
      '&:hover $slider': {
        borderColor: colorBorder.hover
      }
    },
    disabled: {
      opacity: toneValueBase,
      cursor: 'default'
    },
    input: {
      display: 'none'
    },
    label: {
      position: 'relative',
      width: '100%',
      height: '100%',
      borderRadius: '15px',
      backgroundColor: colorIconSecondary.normal,
      transition: "all " + animationDurationM + " " + transitionEasingDefault,
      zIndex: 0
    },
    slider: {
      backgroundColor: colorIconContrast.normal,
      borderRadius: '100%',
      position: 'absolute',
      width: sliderDiameter,
      height: sliderDiameter,
      top: sliderMargin,
      left: sliderMargin,
      transition: "all " + animationDurationM + " " + transitionEasingDefault,
      zIndex: 2
    },
    checked: {
      '& $slider': {
        left: switchWidth - sliderDiameter - sliderMargin
      },
      '& $label': {
        backgroundColor: colorPrimary.normal
      }
    },
    compact: {
      width: compactSwitchWidth,
      height: compactSwitchHeight,
      transitionDuration: animationDurationS,
      '& $slider': {
        width: compactSliderDiameter,
        height: compactSliderDiameter,
        top: compactSliderMargin,
        left: compactSliderMargin,
        transitionDuration: animationDurationS
      },
      '&$checked $slider': {
        left: compactSwitchWidth - compactSliderDiameter - compactSliderMargin
      }
    }
  };
};